import React from 'react';
import { useNavigate } from 'react-router';
import AdvisorPreview from '../home_page/nested_views/advisor_preview';
import classes from './classes.module.scss';
import { advisorsEmptyList, filterIsApplied } from '../../config/util';
import { SvgIcon } from '../../../common/sprites';
import SeeMoreBtn from './see_more_btn';

const cleanFiltersItem = (isLastPage, t, clearFilters, advisors) => {
  if (!filterIsApplied({ withSearch: true })) return null;
  if (isLastPage || (advisors || []).length === 0) {
    return (
      <div className={ classes.filterButtonContainer }>
        <span className={ classes.noFilterTitle }>
          { t('home_page.did_not_find_what_you_wer_looking_for') }
          <br />
          { t('home_page.clear_your_search_filters') }
        </span>
        <button type="button" className={ classes.bottomButton } onClick={ clearFilters } data-testid="clear-filters-btn">
          <SvgIcon id="clear_filters" className={ classes.clearFilterIcon } />
          { t('home_page.clear_filters') }
        </button>
      </div>
    );
  }
  return null;
};

const renderAdvisorsList = (loading, advisors, renderAdvisorListSection) => {
  const loadingAdvisors = loading ? advisorsEmptyList(5, true) : [];
  const advisorsList = [...advisors, ...loadingAdvisors];
  return (
    <div className={ classes.advisorsContainer } data-testid="advisors-list">
      { advisorsList.map((advisor, index) => (renderAdvisorListSection(advisor, index))) }
    </div>
  );
};

function AdvisorsList({
  advisors = [],
  theme = 'searchResult',
  isLastPage = true,
  loadAdvisors,
  loading,
  analytics,
  params,
  t,
  slug,
  lastPageNum,
  seenPages = [],
  page = 1,
  sectionIndex = 0
}) {
  const history = useNavigate();

  const renderAdvisorListSection = (advisor, index) => (
    <AdvisorPreview
      key={ !loading ? advisor.id : `emptyAdvisorSection_${ index }` }
      advisor ={ advisor }
      theme={ theme }
      advisorCount={ 4 }
      loading={ advisor.loading }
      analytics={ analytics }
      sectionSlug={ slug }
      sectionIndex={ sectionIndex }
      itemIndex={ index }
    />
  );

  const clearFilters = () => {
    history(`${ window.location.pathname }`, { state: { needRefresh: true }, replace: true });
  };
  return (
    <div className={ classes[`${ theme }`] }>
      { renderAdvisorsList(loading, advisors, renderAdvisorListSection) }
      { cleanFiltersItem(isLastPage, t, clearFilters, advisors) }
      <SeeMoreBtn
        isLastPage={ isLastPage }
        loading={ loading }
        loadAdvisors={ loadAdvisors }
        theme={ theme }
        slug={ slug }
        analytics={ analytics }
        params={ params }
        lastPageNum={ lastPageNum }
        seenPages={ seenPages }
        page={ page }
      />
    </div>
  );
}

export default AdvisorsList;
